module.exports = __webpack_public_path__ + "media/images/airtel-money copy-c456752fdbcfb42bebfb070c460f6e35.png";